import type { GetBookingSummaryResponse } from '@linktivity/tata';
import { action, observable, reaction } from 'mobx';
import { bookingsApi } from '~/services';
import { syncQueryParam } from '~/utils/state';

export class BookingStore {
  @observable accessor bookingId = '';
  @observable accessor booking: GetBookingSummaryResponse | null = null;

  // Identifies the latest load() so stale responses can be discarded.
  private loadSeq = 0;

  constructor() {
    // Mirror the booking id into the URL so the view can be shared and
    // restored across reloads.
    reaction(
      () => this.bookingId,
      bookingId => syncQueryParam('bookingId', bookingId)
    );

    // (Re)load whenever the booking id changes. fireImmediately also covers
    // the initial load once Base sets the booking id.
    reaction(
      () => this.bookingId,
      () => this.load(),
      { fireImmediately: true }
    );
  }

  @action
  setBookingId(bookingId: string) {
    this.bookingId = bookingId;
  }

  @action
  setBooking(booking: GetBookingSummaryResponse | null) {
    this.booking = booking;
  }

  @action
  async load() {
    const { bookingId } = this;
    if (!bookingId) return;
    const seq = ++this.loadSeq;

    try {
      const data = await bookingsApi.getBookingSummary({ bookingId });
      if (seq !== this.loadSeq) return;
      this.setBooking(data);
    } catch (error) {
      console.error('Failed to load booking summary', error);
    }
  }
}

export default new BookingStore();
